<template>
<div class="chapter">
<div class="inner_page">
<div class="box"><a id="page_2"></a>
<p class="ded">This book is gratefully dedicated to the makers of over 12,000 quilts upon which I doodled my designs while learning how to draw these quilting designs. Thank you to Karen Nelson, Bernice Townsend, Meg Blau, Carolyn Griffin, and Cathryn Zeleny for producing some quilted samples of these designs. Thanks to Ron Paul for keeping me swept off my feet.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?2d27d1bc